import { Link } from "react-router-dom";
import { FaRegEnvelope } from "react-icons/fa";
import { CiStar, CiWarning } from "react-icons/ci";
import { IoIosSend } from "react-icons/io";
import { LuPencil } from "react-icons/lu";
import { TbMessageCircleCog } from "react-icons/tb";
import { RiDeleteBin5Line } from "react-icons/ri";

const SideBar = () => {
  return (
    <div className="w-1/4 p-4 font-helvetica bg-white shadow-md flex flex-col">
      <Link
        to="/dashboard/inbox/compose"
        className="bg-black text-sm text-white py-2 px-4 w-[80%] mx-auto rounded my-6 block text-center"
      >
        + Compose
      </Link>

      <div className="mb-8 w-[80%] mx-auto">
        <h2 className="text-sm text-[#202224] font-semibold mb-4">My Email</h2>
        <ul>
          <li>
            <Link
              to="/dashboard/inbox/"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <FaRegEnvelope />
                <span className="ms-3">Inbox</span>
              </span>
              <span>1253</span>
            </Link>
          </li>
          <li>
            <Link
              to="/starred"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <CiStar />
                <span className="ms-3">Starred</span>
              </span>
              <span>245</span>
            </Link>
          </li>
          <li>
            <Link
              to="/sent"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <IoIosSend />
                <span className="ms-3">Sent</span>
              </span>
              <span>24,532</span>
            </Link>
          </li>
          <li>
            <Link
              to="/draft"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <LuPencil />
                <span className="ms-3">Draft</span>
              </span>
              <span>09</span>
            </Link>
          </li>
          <li>
            <Link
              to="/spam"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <CiWarning />
                <span className="ms-3">Spam</span>
              </span>
              <span>14</span>
            </Link>
          </li>
          <li>
            <Link
              to="/important"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <TbMessageCircleCog />
                <span className="ms-3">Important</span>
              </span>
              <span>18</span>
            </Link>
          </li>
          <li>
            <Link
              to="/bin"
              className="flex justify-between items-center font-normal text-sm p-2 text-[#000000] rounded-lg hover:bg-[#DDDDDD] hover:text-black group"
            >
              <span className="flex items-center">
                <RiDeleteBin5Line />
                <span className="ms-3">Bin</span>
              </span>
              <span>9</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
